import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconLightning20(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={20}
            height={20}
            className={customClassName}
            name="IconLightning20"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M3.749 12.793c-1.557-.004-2.334-1.886-1.233-2.987l8.286-8.283c1.311-1.311 3.494.05 2.893 1.804l-1.11 3.24h3.733c1.559 0 2.34 1.885 1.237 2.988l-8.521 8.519c-1.315 1.315-3.503-.058-2.89-1.814l1.206-3.456zm-.172-1.926a.25.25 0 0 0 .176.427l4.654.013 1.053.003-.347.994-1.553 4.45c-.029.082-.02.135-.005.17.017.043.053.09.108.124a.27.27 0 0 0 .16.044c.037-.003.088-.017.15-.079l8.521-8.519a.25.25 0 0 0-.176-.427h-5.832l.34-.992 1.45-4.234a.23.23 0 0 0 .004-.17.27.27 0 0 0-.108-.123.27.27 0 0 0-.16-.043c-.037.003-.088.017-.15.078z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconLightning20);
